import * as React from "react";
import {observer} from "mobx-react";
import moment, {Moment} from "moment";
import {DatePicker, Button, message} from "antd";
import {injectIntl, InjectedIntlProps, FormattedMessage} from "react-intl";
import empty from "../../../assets/image/empty.svg";
import {
    Chart,
    LineAdvance,
} from "bizcharts";
import {dataStore} from "src/models/DataStore";
import {consoleApi, ConversionTimeEnum} from "src/apiMiddleware";
import {driverStore} from "src/models/DriverStore";
import {roomStore, ServiceData} from "src/models/RoomStore";
import {Link} from "@netless/i18n-react-router";
import {ServiceTypeEnum} from "../serviceCenter/ProjectDetail";
import {LoadingOutlined} from "@ant-design/icons/lib";
import SwitchRegion from "../../SwitchRegion";

const {RangePicker} = DatePicker;

export type StaticConversionDataProps = InjectedIntlProps;
export type StaticConversionDataStates = {
    searchText: any;
    static_qps_list: any[];
    isMaskLoading: boolean;
};

export type StaticQpsMax = {
    qps: number;
    date: string;
};

@observer
class StaticConversionData extends React.Component<StaticConversionDataProps, StaticConversionDataStates> {
    public constructor(props: StaticConversionDataProps) {
        super(props);
        this.state = {
            searchText: "",
            static_qps_list: [],
            isMaskLoading: false,
        };
    }

    private handleRangePicker = async (dates: [Moment, Moment]): Promise<void> => {
        const startDay = dates[0].startOf("day").valueOf();
        const endDay = dates[1].startOf("day").valueOf();
        await dataStore.getStaticConversionQps(startDay, endDay, ConversionTimeEnum.day);
    }

    public async componentDidMount(): Promise<void> {
        try {
            this.setState({isMaskLoading: true});
            const timestamp = new Date().getTime();
            const endDay = moment(timestamp).startOf("day").valueOf();
            const startDay = moment(timestamp).subtract(7, "d").startOf("day").valueOf();
            const resp = await consoleApi.data.getConversionData(1, startDay, endDay, ConversionTimeEnum.day);
            if (resp.code === 200) {
                this.setState({static_qps_list: resp.data.QPSList});
            }
            await driverStore.getServiceQPS(ServiceTypeEnum.static_conversion);
            await roomStore.getService();
            this.setState({isMaskLoading: false});
        } catch (err) {
            message.error(err.message);
            this.setState({isMaskLoading: false});
        }
    }

    private detectServiceEnable = (): boolean => {
        if (roomStore.productState.length > 0) {
            const myService: ServiceData | undefined =
                roomStore.productState.find(data => data.type === ServiceTypeEnum.static_conversion);
            if (myService) {
                return myService.enable;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    private renderMask = (): React.ReactNode => {
        if (this.state.isMaskLoading) {
            return (
                <div className="content-box-mask">
                    <LoadingOutlined style={{fontSize: 36, color: "#3381FF"}} />
                </div>
            );
        } else {
            return null;
        }
    }
    public render(): React.ReactNode {
        const {intl} = this.props;
        const {static_qps_list} = this.state;
        let dayDataArray: StaticQpsMax[] = [];
        if (static_qps_list.length > 0) {
            dayDataArray = static_qps_list.map(data => {
                return {
                    date: moment(data.checkDate).format("MMM Do"),
                    qps: data.maxQPS,
                    type: intl.formatMessage({id: "global.document-to-picture"}),
                };
            });
        }
        if (!this.detectServiceEnable()) {
            return (
                <div className="product-center-box">
                    <div className="portal-room-outbox">
                        <div className="portal-room-chart">
                            <div className="portal-room-box-mid">
                                <div style={{ position: "absolute", marginTop: 16, marginLeft: 20 }}>
                                    <SwitchRegion onChange={() => this.componentDidMount()} />
                                </div>
                                <div className="portal-dynamic-empty">
                                    <img style={{marginBottom: 28}} src={empty} alt={"empty"}/>
                                    <Link to={`/projects/`}>
                                        <Button size="large" type="primary">
                                            {intl.formatMessage({id: "dash.open-service"})}
                                        </Button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="product-center-box">
                <div className="portal-room-outbox">
                    <div className="portal-room-chart">
                        <div className="portal-room-box-mid">
                            {this.renderMask()}
                            <div className="console-content-title-max">
                                <span className="console-content-title-text">
                                    <FormattedMessage
                                        id="global.qps-image-peak"
                                    />
                                </span>
                                <div>
                                    <span className="clipboard-innerbox-text-region">
                                        <SwitchRegion onChange={() => this.componentDidMount()} />
                                    </span>
                                    <RangePicker
                                        onChange={this.handleRangePicker}
                                        style={{marginRight: 20}}/>
                                </div>
                            </div>
                            <div className="console-content-chart-body">
                                <div className="console-content-chart-box">
                                    <div className="console-content-chart-text">
                                        <div><FormattedMessage
                                            id="global.qps-number"
                                        />: {driverStore.static_conversion}</div>
                                    </div>
                                    <Chart autoFit
                                           padding={[20, 120, 96, 120]}
                                           width={1200}
                                           height={300} data={dayDataArray}>
                                        <LineAdvance
                                            shape="smooth"
                                            point
                                            area
                                            position="date*qps"
                                            color={["type", ["#3381FF"]]}
                                        />
                                    </Chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default injectIntl(StaticConversionData);



// WEBPACK FOOTER //
// ./src/components/portal/dataCenter/StaticConversionData.tsx